import { Component, OnInit, Input } from '@angular/core';
import { EnglishCourse } from 'src/app/models/english-course';
import { Router } from '@angular/router';

@Component({
  selector: 'app-english-course-item',
  templateUrl: './english-course-item.component.html',
  styleUrls: ['./english-course-item.component.css']
})
export class EnglishCourseItemComponent implements OnInit {

  @Input() course:EnglishCourse = new EnglishCourse()

  constructor(
    private router:Router
  ) { }

  ngOnInit(): void {
  }

  routeToCourseDetail(id: string) {
    this.router.navigate(['lessons/' + id]);
  }


}
